export const ERROR_MESSAGE = {
    INVALID_THOUGHTSPOT_HOST: 'Error parsing ThoughtSpot host. Please provide a valid URL.',
    LIVEBOARD_VIZ_ID_VALIDATION: 'Please provide either liveboardId or pinboardId',
    TRIGGER_TIMED_OUT: 'Trigger timedout in getting response',
    SEARCHEMBED_BETA_WRANING_MESSAGE: 'Search Embed is in Beta in this release.',
    SAGE_EMBED_BETA_WARNING_MESSAGE: 'Sage Embed is in Beta in this release.',
};
//# sourceMappingURL=errors.js.map